import {ApiClient} from '@hconnect/apiclient'
import {HttpError} from '@hconnect/common/types'
import {useQuery, keepPreviousData} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import moment from 'moment'

import {QueryOptions2Type, SignalTelemetry} from '../types'

export const TelemetryQueryKey = 'telemetry'

export const useGetTelemetry = (
  plantUpmId: string | undefined,
  localNames: string[],
  options?: QueryOptions2Type<SignalTelemetry[], AxiosError<HttpError>>
) => {
  return useQuery<SignalTelemetry[], AxiosError<HttpError>>({
    queryKey: [TelemetryQueryKey, plantUpmId, localNames],
    queryFn: async () => {
      const path = `/kms/${plantUpmId}/signal/last-values`
      return (
        await ApiClient.axiosInstance.post(path, {
          localNames,
          cadAlertQueryLimit: moment().subtract(6, 'hours').toISOString()
        })
      ).data
    },
    placeholderData: keepPreviousData,
    refetchInterval: 1000 * 60,
    enabled: !!plantUpmId && localNames.length > 0,
    ...options
  })
}
